export default function NotFoundPage() {
  return (
    <div>
      <h1>707 ERROR</h1>
      <p>Not found page...</p>
    </div>
  );
}
